module.exports = __webpack_public_path__ + "static/media/woman-working-on-a-laptop.acb8866b.jpg";